import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoginAndRegDialogComponent} from '../../../login/components/login-and-reg-dialog/login-and-reg-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {Locale} from '../../../../core/interfaces/locale';
import {KeyValue} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';
import {filter, switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../../../login/services/auth.service';
import {Account} from '../../../../core/interfaces/account';
import {UserWalletsService} from '../../../../core/services/user-wallets.service';
import {Wallet} from '../../../../core/interfaces/wallet';
import {Subscription} from 'rxjs';
import {interval} from 'rxjs/internal/observable/interval';
import {OrderPanelService} from '../../../../core/services/order-panel.service';
import {IconMessagesConfig} from '../../../../core/interfaces/icon-messages-config';
import {GlobalIconMessages} from '../../../../core/interfaces/global-icon-messages';
import {GlobalMessagesModalComponent} from '../../../../routed/order-panel/global-messages-modal/global-messages-modal.component';
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {

  public localeEnum = Locale;
  public selectedLocale = 'RU';
  public isOpenedMobileMenu = false;
  public account: Account;
  public wallets: Wallet[] = [];
  private additionalParams: any;
  public get mobileMenuIcon(): string {
   return this.isOpenedMobileMenu ? 'close-icon' : 'burger-menu-icon';
  }
  public showWarningMessage = false;
  public showInfoMessage = false;
  public iconMessage: GlobalIconMessages[] = [];
  public warningIntervalSubscription: Subscription;
  constructor(
    private readonly matDialog: MatDialog,
    private readonly translateService: TranslateService,
    private readonly router: Router,
    public readonly authService: AuthService,
    public readonly userWalletsService: UserWalletsService,
    public readonly orderPanelService: OrderPanelService,
    public readonly dialog: MatDialog,
    public readonly cookieService: CookieService
  ) {
    console.log(authService.$account.value, 'LOFFFFF');
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      switchMap( () => this.authService.getAccount()),
      tap( res => {
        this.account = res;
        this.additionalParams = JSON.parse(res.additionalParams);
        if (this.additionalParams.agreeOnBeta) {
          this.cookieService.set('agreeOnBeta', this.additionalParams.agreeOnBeta, {domain: 'donateall.online'});
          this.cookieService.set('agreeOnBeta', this.additionalParams.agreeOnBeta, {domain: 'beta.donateall.online'});
        }
        this.authService.$account.next(res);
      }),
    ).subscribe();

    this.authService.$account.pipe(
      filter(res => res !== null),
      switchMap( () => {
        return this.userWalletsService.getCurrentUserBalance().pipe(
          tap(res => {
            this.wallets = res;
          })
        );
      })
    ).subscribe();

    this.warningIntervalSubscription = interval(5000).pipe(
      switchMap(() => {
        return this.orderPanelService.globalMessagesForStreamer(!!this.account?.login).pipe(
          tap(res => {
            const showModalWithTypeWarning = res.find(data => data.type === 'warning');
            if (res.length > 0) {
              this.iconMessage = res;
              if (showModalWithTypeWarning) {
                this.showWarningMessage = true;
              } else {
                this.showInfoMessage = true;
              }
            } else {
              this.showInfoMessage = false;
              this.showWarningMessage = false;
            }
          })
        );
      })
    ).subscribe();
  }
  ngOnDestroy() {
    this.warningIntervalSubscription.unsubscribe();
  }

  public changeLanguage(selectedLocale: KeyValue<string, string>): void {
    this.selectedLocale = selectedLocale.key;
    this.translateService.use(selectedLocale.value);
  }

  public openAuthModal(): void {
    this.matDialog.open<LoginAndRegDialogComponent>(LoginAndRegDialogComponent, {width: '630px'});
  }

  public toggleMobileMenuIcon(): void {
    this.isOpenedMobileMenu = !this.isOpenedMobileMenu;
  }

  public goToLink(url: string){
    window.open(url, '_blank');
  }

  public logout(): void {
    this.authService.logout();
    this.router.navigate(['']);
  }
  public openWarningMessage(): void {
    const warningData: IconMessagesConfig = {
      iconMessage: this.iconMessage,
      type: 'warning',
      closeModal: true
    };

    const config: MatDialogConfig = {
      width: '609px',
      height: '210',
      data: warningData,
      disableClose: true,
      position: {
        bottom: window.innerWidth <= 650 ? '0' : undefined,
        left: window.innerWidth > 650 ? '0' : undefined,
      }
    };

    const dialogRef = this.dialog.open(GlobalMessagesModalComponent, config);

    dialogRef.afterClosed().pipe(
      switchMap(() => {
        const message = this.iconMessage.find(msg => msg.type === 'warning');
        if (warningData.closeModal) {
          this.showWarningMessage = false;
          return this.orderPanelService.globalMessagesForAdminClosed(message.id);
        }
      })
    ).subscribe();
  }
  public openInfoMessage(): void {
    const infoData: IconMessagesConfig = {
      iconMessage: this.iconMessage,
      type: 'info',
      closeModal: true
    };

    const config: MatDialogConfig = {
      width: '609px',
      height: '210',
      data: infoData,
      disableClose: true,
      position: {
        bottom: window.innerWidth <= 650 ? '0' : undefined,
        left: window.innerWidth > 650 ? '0' : undefined,
      }
    };

    const dialogRef = this.dialog.open(GlobalMessagesModalComponent, config);

    dialogRef.afterClosed().pipe(
      switchMap(() => {
        const message = this.iconMessage.find(msg => msg.type === 'info');
        if (infoData.closeModal) {
          this.showInfoMessage = false;
          return this.orderPanelService.globalMessagesForAdminClosed(message.id);
        }
      })
    ).subscribe();
  }

  exitBeta() {
    this.cookieService.delete('agreeOnBeta', '/', 'beta.donateall.online');
    this.cookieService.delete('agreeOnBeta', '/', 'donateall.online');
    this.additionalParams.agreeOnBeta = undefined;
    this.account = { ...this.account, additionalParams: JSON.stringify(this.additionalParams) };
    this.authService.saveAccount(this.account).subscribe(
      () => {
        window.location.href = 'https://donateall.online';
      }
    );
  }

  hasBeta() {
    return this.cookieService.get('agreeOnBeta') === 'true';
  }

}
